var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"basic-button flex--col-center-center noselect",class:{
    'basic-button--mini': _vm.mini,
    'basic-button--small': _vm.small,
    'basic-button--large': _vm.large,
    'basic-button--snug': _vm.snug,
    'basic-button--outline': _vm.outline,
    'basic-button--no-pointer-events': _vm.noPointerEvents,
    'basic-button--disabled': _vm.disabled
  },style:({ backgroundColor: _vm.buttonColor }),on:{"click":function($event){$event.preventDefault();return (e => _vm.emitClick(e)).apply(null, arguments)}}},[_c('div',{staticClass:"basic-button__text text-commerce-button-primary text--uppercase noselect",class:{
      'text-commerce-button-primary-small': _vm.mini || _vm.small,
      'text-zd-button-large': _vm.large,
      'basic-button__text--outline': _vm.outline,
      'basic-button__text--disabled': _vm.disabled
    },style:({ color: _vm.textColor })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.disabled ? _vm.disabledContent || _vm.content : _vm.content))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }